import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'; 
import nexapi from '../../services/api';
import { ApplicationModel } from '../../types/models/ApplicationModel';
import { notify } from '../../components/UI/notify';
import { NotifyType } from '../../types/enums/notifytype';
import { SubtypeModel } from '../../types/models/SubtypeModel';


interface SubtypesState {
  data: SubtypeModel[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

interface SubtypesResponse {
  subtypes: SubtypeModel[]; // Change to ApplicationModel array instead of any[]
  totalCount: number;
}

// API URL
const API_URL = '/Subtype';
const { message } = notify();

export const fetchSubtypes = createAsyncThunk<SubtypesResponse, {
  filters: Record<string, any>; 
  page: number; 
  numberOfRecord: number;
  userId?: string;
  sortColumn: string;
  sortOrder: 'asc' | 'desc';
  iscompanySubype : boolean }>(
  'subtypes/fetchsubtypes',
  async ({filters, page, numberOfRecord,userId, sortColumn = '', sortOrder = 'asc', iscompanySubype }) => {
    try {
      const payload = {"CreatedBy" : userId};
      const response = await nexapi.post(API_URL + `/GetAll?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&isCompanySubtype=${iscompanySubype}&search=${filters.search}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&state=${filters.state}`,payload);
      const data = response.data;
      if (Array.isArray(data?.data)) {
        return {
          subtypes: data.data, // The list of applications
          totalCount: data.totalCount, // The total count of applications
        };
      } else {
        console.error("Invalid API Response:", data);
        return { subtypes: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);


export const fetchSubtypeById = createAsyncThunk<SubtypesResponse, { id:string }>(
  'subtypes/fetchsubtypes',
  async ({ id}) => {
    
    try {
      const response = await nexapi.post(API_URL + `/GetAllFieldByID?Id=${id}`);
      const data = response.data;
return {
  subtypes: data.data, // The list of applications
  totalCount: data.totalCount, // The total count of applications
};
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);


// export const deleteSubtypes = createAsyncThunk('subtypes/deleteSubtypes', async (id:any) => {
//   try {
//   await nexapi.delete(`${API_URL}/${id}`);
//   return id;
// } catch (error) {
//   return error.message
// }
// });


export const deleteSubtypes = createAsyncThunk<SubtypesResponse, { Id : string, UserId:string,reason: string}>(
  'subtypes/deleteSubtypes',
  async ({ Id,UserId,reason}) => {
    
    try {
      const [cleanId] = Id.includes('_') ? Id.split('_') : [Id];

      const payload = {
        Id: cleanId,
        UserId: UserId,
        reason: reason
      };
      const url = API_URL+"/ActivateDeactivateSubtype";
      const method = "post";
      const response = await nexapi[method](url, payload);

      
      response.data.statusCode = "200";
      return response.data.statusCode;
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

const initialState: SubtypesState = {
  data: [],
  totalRecords: 0,
  currentPage: 0,
  loading: false,
  error: null,
  status: 'idle',
};

// Slice
const subtypesSlice = createSlice({
  name: 'subtypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubtypes.fulfilled, (state, action) => {
        // Assuming action.payload contains applications and totalCount
        state.data = action.payload.subtypes;
        state.totalRecords = action.payload.totalCount;
        state.status = 'succeeded';
      })
  
      .addCase(deleteSubtypes.fulfilled, (state, action:any) => {
        state.data = state.data.filter((app) => app.id !=  action.payload);
        state.status = 'succeeded';
      }) 

      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';          
        }
      );
  },
});

export default subtypesSlice.reducer;